/* Aroma Box – JS robust (delegare evenimente + fallback) */
(function () {
  if (window.__ABX_RUNNING__) return;
  window.__ABX_RUNNING__ = true;

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('aroma-box');
    if (!root) { console.warn('ABX: #aroma-box not found'); return; }

    var boxEl       = root.querySelector('#abx-box');
    var grid        = root.querySelector('#abx-grid');

    var slotImgs    = [].slice.call(root.querySelectorAll('[data-slot-img]'));
    var slotTitles  = [].slice.call(root.querySelectorAll('[data-slot-title]'));
    var slotBtns    = [].slice.call(root.querySelectorAll('.abx-btn'));

    var sum1        = root.querySelector('#sum-1');
    var sum2        = root.querySelector('#sum-2');
    var sum3        = root.querySelector('#sum-3');
    var totalEl     = root.querySelector('#abx-total');
    var addBtn      = root.querySelector('#abx-add');
    var checkoutBtn = root.querySelector('#abx-checkout');

    // Quick View refs (există în secțiune)
    var qv       = root.querySelector('#qv');
    var qvImg    = root.querySelector('#qv-img');
    var qvTitle  = root.querySelector('#qv-title');
    var qvPrice  = root.querySelector('#qv-price');
    var qvDesc   = root.querySelector('#qv-desc');
    var qvAdd    = root.querySelector('#qv-add');
    var qvClose  = root.querySelector('#qv-close');
    var qvCancel = root.querySelector('#qv-cancel');

    // Config
    var DECANT_MOCK =
      'https://cdn.shopify.com/s/files/1/0697/9878/9167/files/Untitled_design_-_2025-09-28T135942.988.png?v=1759057246';

    var FREE_BOX = 0;
    var freeBoxAttr = root.getAttribute('data-free-box');
    if (freeBoxAttr && !isNaN(+freeBoxAttr)) FREE_BOX = +freeBoxAttr;

    // State
    var selections = [null, null, null]; // {variant, title, price, img}
    var activeSlot = 0;

    // Utils
    function moneyToCents(str) {
      if (!str) return 0;
      var n = String(str).replace(/[^\d.,]/g, '').replace('.', '').replace(',', '.');
      var f = parseFloat(n);
      return isNaN(f) ? 0 : Math.round(f * 100);
    }
    function fmt(cents) { return (cents / 100).toFixed(2) + ' MDL'; }

    function updateTotal() {
      var total = selections.reduce(function (acc, x) { return acc + (x ? moneyToCents(x.price) : 0); }, 0);
      if (totalEl) totalEl.textContent = fmt(total);
    }

    function updateSummaries() {
      function s(obj, i) { return obj ? (obj.title + ' – ' + obj.price) : ('Parfum nr.' + (i + 1)); }
      if (sum1) sum1.textContent = s(selections[0], 0);
      if (sum2) sum2.textContent = s(selections[1], 1);
      if (sum3) sum3.textContent = s(selections[2], 2);
      updateTotal();
    }

    function renderSlot(i) {
      var sel   = selections[i];
      var imgEl = slotImgs[i];
      var ttlEl = slotTitles[i];
      var slot  = ttlEl ? ttlEl.closest('.abx-slot') : null;
      var btn   = slot ? slot.querySelector('.abx-btn') : null;

      if (!imgEl || !ttlEl || !slot || !btn) return;

      if (sel) {
        imgEl.src = DECANT_MOCK;
        imgEl.style.display = 'block';
        ttlEl.textContent = sel.title;
        slot.classList.add('filled');
        btn.textContent = 'Înlocuiește parfumul';
      } else {
        imgEl.removeAttribute('src');
        imgEl.style.display = 'none';
        ttlEl.textContent = 'Parfum nr.' + (i + 1);
        slot.classList.remove('filled');
        btn.textContent = 'Alege parfumul';
      }
    }

    function renderAll() {
      renderSlot(0); renderSlot(1); renderSlot(2);
      updateSummaries();
    }

    function firstEmptyIndex() {
      for (var i = 0; i < selections.length; i++) if (!selections[i]) return i;
      return -1;
    }

    function ensureThreeSelected() {
      var ok = selections[0] && selections[1] && selections[2];
      if (!ok) alert('Selectează toate cele 3 parfumuri.');
      return ok;
    }

    function scrollToGrid() {
      if (!grid) return;
      var top = grid.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function scrollToBox() {
      if (!boxEl) return;
      var top = boxEl.getBoundingClientRect().top + window.scrollY - 40;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // Delegare click pe întreaga secțiune
    root.addEventListener('click', function (e) {
      var t;

      // Slot button (+Alege/Înlocuiește)
      t = e.target.closest('.abx-btn');
      if (t && root.contains(t)) {
        e.preventDefault();
        var idx = parseInt(t.getAttribute('data-slot'), 10) || 0;
        activeSlot = idx;
        scrollToGrid();
        return;
      }

      // Step button (dreapta)
      t = e.target.closest('.abx-step-btn');
      if (t && root.contains(t)) {
        e.preventDefault();
        var step = parseInt(t.getAttribute('data-step'), 10) || 0;
        activeSlot = step;
        scrollToGrid();
        return;
      }

      // Quick View open
      t = e.target.closest('.js-qv');
      if (t && root.contains(t)) {
        e.preventDefault();
        if (!qv) return;
        var title = t.getAttribute('data-title') || '';
        var price = t.getAttribute('data-price') || '';
        var img   = t.getAttribute('data-img') || '';
        var desc  = t.getAttribute('data-desc') || '';
        // variant îl luăm din butonul pereche .js-choose din același card
        var card = t.closest('.pcard');
        var chooseBtn = card ? card.querySelector('.js-choose') : null;
        var variant = chooseBtn ? chooseBtn.getAttribute('data-variant') : '';

        qvImg && (qvImg.src = img);
        qvTitle && (qvTitle.textContent = title);
        qvPrice && (qvPrice.textContent = price);
        qvDesc && (qvDesc.textContent = desc);
        qv.setAttribute('data-variant', variant);
        qv.setAttribute('data-title', title);
        qv.setAttribute('data-price', price);
        qv.style.display = 'flex';
        return;
      }

      // Quick View close areas
      if (qv && (e.target === qv || e.target === qvClose || e.target === qvCancel)) {
        e.preventDefault();
        qv.style.display = 'none';
        return;
      }

      // Quick View: Alege parfumul
      if (qv && e.target === qvAdd) {
        e.preventDefault();
        var d = {
          variant: Number(qv.getAttribute('data-variant') || '0'),
          title:   qv.getAttribute('data-title') || '',
          price:   qv.getAttribute('data-price') || '',
          img:     DECANT_MOCK
        };
        var empty = firstEmptyIndex();
        activeSlot = (empty === -1 ? activeSlot : empty);
        selections[activeSlot] = d;
        renderAll();
        qv.style.display = 'none';
        scrollToBox();
        return;
      }

      // Grid: Alege parfum direct
      t = e.target.closest('.js-choose');
      if (t && root.contains(t)) {
        e.preventDefault();
        var data = {
          variant: Number(t.getAttribute('data-variant') || '0'),
          title:   t.getAttribute('data-title') || '',
          price:   t.getAttribute('data-price') || '',
          img:     DECANT_MOCK
        };
        var emptyIdx = firstEmptyIndex();
        activeSlot = (emptyIdx === -1 ? activeSlot : emptyIdx);
        selections[activeSlot] = data;
        renderAll();
        scrollToBox();
        return;
      }
    });

    // Add to cart + Checkout (direct listeners ca fallback)
    function itemsPayload() {
      var items = [];
      if (FREE_BOX && (selections[0] || selections[1] || selections[2])) {
        items.push({
          id: FREE_BOX,
          quantity: 1,
          properties: {
            "_Bundle": "Aroma Box",
            "Parfum 1": selections[0] ? selections[0].title : "-",
            "Parfum 2": selections[1] ? selections[1].title : "-",
            "Parfum 3": selections[2] ? selections[2].title : "-"
          }
        });
      }
      for (var i = 0; i < selections.length; i++) {
        var s = selections[i];
        if (!s) continue;
        items.push({
          id: Number(s.variant || 0),
          quantity: 1,
          properties: { "În Aroma Box": "Slot " + (i + 1) }
        });
      }
      return items;
    }

    function addItemsThen(goTo) {
      if (!ensureThreeSelected()) return;
      try {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsPayload() })
        })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () { window.location.href = goTo; })
          .catch(function () { alert('Nu am putut continua. Încearcă din nou.'); });
      } catch (e) {
        alert('Nu am putut continua. Încearcă din nou.');
      }
    }

    if (addBtn) addBtn.addEventListener('click', function () { addItemsThen('/cart'); });
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { addItemsThen('/checkout'); });

    // Poster automat pentru video (fără optional chaining)
    (function autoPoster() {
      try {
        var v = root.querySelector('.abx-video');
        if (!v || !v.getAttribute('data-auto-poster')) return;
        v.crossOrigin = 'anonymous';
        v.addEventListener('loadeddata', function () {
          try {
            var c = document.createElement('canvas');
            c.width = 1280; c.height = 720;
            var ctx = c.getContext('2d');
            ctx.drawImage(v, 0, 0, c.width, c.height);
            v.setAttribute('poster', c.toDataURL('image/jpeg', 0.72));
            v.pause(); v.currentTime = 0;
          } catch (e) {}
        }, { once: true });
      } catch (e) {}
    })();

    // Init
    renderAll();
    console.log('ABX ready');
  });
})();
